import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';

const styles = (theme) => ({
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question : {
		padding: '20px 20px 10px 20px',
		fontWeight : 600,
		fontSize : 16,
		textAlign : 'right',
	},
	actions : {
		padding : 10,
	},
	warningButton : {
		borderRadius : 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});


class ConfirmInvalidateBulkInvoiceDialog extends PureComponent {

	constructor (props) {
		super(props);
		this.state = {
			invalidReason : '',
		};
	}

	onChange = (event, fieldName) => {
		this.setState({ [fieldName] : event.target.value });
	};

	handleClose = () => {
		this.props.onClose();
	};

	handleInvalidate = () => {
		const {
			//onClose,
			showErrors,
			bulkInvoice,
			invalidateBulkInvoice,
		} = this.props;
		const { invalidReason } = this.state;

		if (!invalidReason) {
			showErrors(['A reason for marking invoice invalid is required.']);
			return;
		}

		if (!bulkInvoice) {
			return showErrors(['Missing bulk invoice']);
		}

		invalidateBulkInvoice({
			params : {
				invalidReason,
				bulkInvoiceId : bulkInvoice.bulkInvoiceId,
			},
			callback : (err) => {
				if (!err) {
					this.props.history.push(`/accounting/bulkInvoices`);
				}
			}
		});
	};

	render() {
		const { classes, open } = this.props;
		return (
			<Dialog
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<DialogTitle>Invalidate Bulk Invoice</DialogTitle>
				<DialogContent>
					<TextField
						value={this.state.invalidReason}
						onChange={event => this.onChange(event, 'invalidReason')}
						label="Reason for marking invoice invalid"
						fullWidth
					/>
				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to mark this invoice invalid?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>
							Close
						</Button>
						<Button
							variant="contained"
							onClick={this.handleInvalidate}
							className={classes.warningButton}
						>
							Yes, mark invoice as invalid
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmInvalidateBulkInvoiceDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,

	//- Could be either
	bulkInvoice : PropTypes.object,
	history : PropTypes.object.isRequired,

	invalidateBulkInvoice : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmInvalidateBulkInvoiceDialog);